<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>分类管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="分类名称：">
              <el-select size="small" v-model="listParams.goodCategoryId" style="width: 100%" clearable>
                <el-option v-for="item in categoryNameList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column align="center" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="分类名称"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="分类名称 ：" prop="title">
            <el-input v-model="itemParams.title" size="small" placeholder="请输入分类名称"> </el-input>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveCategoryNameItem('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        goodCategoryId: "",
        supplyId: "",
      },
      categoryNameList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      itemParams: {
        title: "",
        supplyId: "",
      },
      bodyParams: {},
      method: "",
      checkItemParams: {
        title: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      isDisabled: false,
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.itemParams.supplyId = this.$route.params.supplyId;
    this.loadCategoryList();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化加载分类名称
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const dataList = res.body.data;
            dataList.unshift({ id: "", title: "全部" });
            this.categoryNameList = dataList;
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findByPage",
        method: "GET",
        params: {
          goodCategoryId: this.listParams.goodCategoryId,
          supplyId: this.listParams.supplyId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.dialogTitle = "新增分类管理条目";
      this.dialogVisible = true;
      this.method = "POST";
      this.itemParams.title = "";
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 保存新增或修改
     * @param name
     */
    saveCategoryNameItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign(this.itemParams, {
            type: "categoryList_" + this.tableData.length,
          });
          this.$http({
            url: global.apiUrl + "/good/goodcategory",
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑分类管理条目";
      Object.assign(this.itemParams, row);
      this.dialogVisible = true;
      this.method = "PUT";
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/good/goodcategory?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
